var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar-nav',{staticClass:"nav"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.showChat = true}}},[_c('feather-icon',{attrs:{"icon":"MessageSquareIcon","size":"21"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }